export const countdata = 
[
    {
      title : "EXPERIENCE",
      num : 8,
      decimal : 0,
    },
    {
      title : "MANUFACTURING SETUP (SqFt)",
      num : 7000,
      decimal : 0,
    },
    {
      title : "DEDICATED TEAM",
      num : 100,
      decimal : 0,
    }
]

export const aboutdata = {
  img : "./images/aboutjew.webp",
  head : "ABOUT US",
  para : "Welcome to FABGOLD, where exquisite craftsmanship meets timeless elegance. We are a renowned jewellery manufacturer dedicated to creating exquisite pieces that captivate the senses and celebrate life's most precious moments."
}

export const aboutdetails = [
  {
    id : 1,
    head : "Our Story",
    para : "Established 2017, FABGOLD has been at the forefront of the jewellery industry, blending traditional artistry with contemporary design. From our humble beginnings as a small workshop to our current status as a leading manufacturer, our journey has been defined by passion, innovation, and a commitment to excellence."

  },
  {
    id : 2,
    head : "Our Mission",
    para : "At FABGOLD, our mission is to craft jewellery that inspires and delights. We strive to exceed our customers' expectations by offering unparalleled quality, impeccable craftsmanship, and exceptional service. Every piece we create is a testament to our dedication to beauty, sophistication, and perfection."

  },
  {
    id : 3,
    head : "Our Craftsmanship",
    para : "Each FABGOLD piece is meticulously crafted by skilled artisans who bring decades of experience and expertise to every creation. From the initial design concept to the final finishing touches, we uphold the highest standards of craftsmanship, ensuring that every detail is perfect and every gemstone is exquisite."

  },
  {
    id : 4,
    head : "Our Collections",
    para : "Explore our diverse collections, each meticulously curated to showcase the beauty of fine jewelry. Whether you're searching for a dazzling ring, a statement-making necklace, or a timeless pair of earrings, our collections offer something for every style and occasion."

  },
  {
    id : 5,
    head : "Our Commitment to Sustainability",
    para : "At FABGOLD, we are committed to sustainability and ethical practices. We source our materials responsibly, using conflict-free  STONES and ethically sourced gemstones. By prioritizing sustainability throughout our supply chain, we strive to minimize our environmental impact and create a brighter future for generations to come."

  },

]